// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y6u4J","option":"styles_option__2Ykr1","active":"styles_active__36k68"};